var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"summary-vehicle-repairable-chart\" class=\"summary-charts\"></div>\n<div id=\"summary-vehicle-repairable-table\" class=\"summary-charts\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/summary-vehicle-repairable-after-sales.hbs
// module id = wpZo
// module chunks = 1